
      
         const alyna_home_hero_main_banner_card =
             document.querySelector(
                 '.alyna_home_hero_main_banner_product_card'
             );
         
         
         const alyna_home_hero_main_banner_section =
             document.querySelector(
                 '#alyna_home_hero_main_banner_section'
             );
         
         
         
         window.addEventListener('scroll', () => {
         
         
             const rect =
                 alyna_home_hero_main_banner_section.getBoundingClientRect();
         
         
         
             const progress = Math.min(
                 Math.max(
         
                     -window.scrollY /
                     window.innerHeight
         
                     + 1
         
                     , 0)
         
                 , 1);
         
         
         
             let opacity = progress;
         
             let move = (1 - progress) * 180;
         
         
         
             alyna_home_hero_main_banner_card.style.opacity =
                 opacity;
         
         
         
             alyna_home_hero_main_banner_card.style.transform =
         
                 `translateY(${move}px)`;
         
         
         
         });
         
      


<!-- collection -->
 
    document.querySelectorAll('.features_collection_main_right_cat_box').forEach(box => {

    box.addEventListener('mousemove', function(e) {

        const rect = this.getBoundingClientRect();

        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;

        const moveX = (x - rect.width / 2) / 12;
        const moveY = (y - rect.height / 2) / 12;

        this.style.transform = `translate(${moveX}px, ${moveY}px)`;
    });

    box.addEventListener('mouseleave', function() {
        this.style.transform = 'translate(0,0)';
    });

});
 

 <!-- middle banner -->
  
    const banner = document.querySelector('.alyna_hoe_middle_banner_row');

const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
        if(entry.isIntersecting){
            entry.target.classList.add('animate');
            observer.unobserve(entry.target); // animate only once
        }
    });
},{
    threshold:0.3
});

observer.observe(banner);
  

  <!-- bubble sec -->
 

window.addEventListener("load", function(){

    const section = document.querySelector(".gear_up_ypur_kids_main_sec");

    if(section){

        const observer = new IntersectionObserver((entries)=>{

            entries.forEach((entry)=>{

                if(entry.isIntersecting){

                    section.classList.add("active");

                    observer.disconnect();

                }

            });

        },{

            threshold:0.3

        });

        observer.observe(section);

    }

});


<!-- marquee -->
 
    const track = document.querySelector('.marquee_track');

for(let i = 0; i < 100; i++){
    const item = document.createElement('h2');
    item.textContent = 'Big Adventures Designed for Kids';
    track.appendChild(item);
}
 



// contat slider


document.addEventListener("DOMContentLoaded", function () {

    const track = document.getElementById("ankit_toy_contact_slider_track");

    const originals = [...track.children];

    // Duplicate 50 times
    for(let i=0;i<50;i++){

        originals.forEach(item=>{
            track.appendChild(item.cloneNode(true));
        });

    }

    let position = track.scrollWidth / 2;
    let speed = 0.8;

    function animate(){

        position -= speed;

        if(position <= 0){
            position = track.scrollWidth / 2;
        }

        track.style.transform = `translate3d(${-position}px,0,0)`;

        requestAnimationFrame(animate);

    }

    requestAnimationFrame(animate);

});